import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';

const setCampaignEditorTemplateMounted = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<boolean>) => {
    state.templateMounted = action.payload;
  });

export default setCampaignEditorTemplateMounted;
